import { render, staticRenderFns } from "./__ChangePassword.vue?vue&type=template&id=cd47f920"
import script from "./__ChangePassword.vue?vue&type=script&lang=js"
export * from "./__ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports